import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="bg-secondary-600/40 rounded-2xl p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-secondary-400/20 rounded-full -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-secondary-400/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>

            <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8">
              <div className="md:col-span-4">
                <Link to="/" className="font-heading font-bold text-xl text-white">
                  黑料吃瓜网
                </Link>
                <p className="mt-3 text-sm text-background-50/70 leading-relaxed max-w-xs">
                  每日更新热门黑料、网红塌房爆料与不打烊吃瓜资源。一站直达最新大瓜现场，做最懂你的吃瓜平台。
                </p>
              </div>

              <div className="md:col-span-2">
                <h4 className="text-xs font-medium uppercase tracking-wider text-background-50/50 mb-4">分类导航</h4>
                <ul className="space-y-2.5">
                  {categories.slice(0, 3).map((cat) => (
                    <li key={cat.slug}>
                      <Link
                        to={`/category/${cat.slug}`}
                        className="text-sm text-background-50/70 hover:text-white transition-colors"
                      >
                        {cat.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="md:col-span-2">
                <h4 className="text-xs font-medium uppercase tracking-wider text-background-50/50 mb-4">更多分类</h4>
                <ul className="space-y-2.5">
                  {categories.slice(3).map((cat) => (
                    <li key={cat.slug}>
                      <Link
                        to={`/category/${cat.slug}`}
                        className="text-sm text-background-50/70 hover:text-white transition-colors"
                      >
                        {cat.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="md:col-span-2">
                <h4 className="text-xs font-medium uppercase tracking-wider text-background-50/50 mb-4">关于</h4>
                <ul className="space-y-2.5">
                  <li>
                    <Link to="/about" className="text-sm text-background-50/70 hover:text-white transition-colors">
                      关于我们
                    </Link>
                  </li>
                  <li>
                    <a href="#" className="text-sm text-background-50/70 hover:text-white transition-colors">
                      联系我们
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-sm text-background-50/70 hover:text-white transition-colors">
                      投稿爆料
                    </a>
                  </li>
                </ul>
              </div>

              <div className="md:col-span-2">
                <h4 className="text-xs font-medium uppercase tracking-wider text-background-50/50 mb-4">法律</h4>
                <ul className="space-y-2.5">
                  <li>
                    <a href="#" className="text-sm text-background-50/70 hover:text-white transition-colors">
                      隐私政策
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-sm text-background-50/70 hover:text-white transition-colors">
                      服务条款
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-sm text-background-50/70 hover:text-white transition-colors">
                      免责声明
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/50">
              &copy; 2026 黑料吃瓜网 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-background-50/50">
              <a href="#" className="hover:text-white transition-colors">隐私政策</a>
              <span className="text-background-50/20">|</span>
              <a href="#" className="hover:text-white transition-colors">服务条款</a>
              <span className="text-background-50/20">|</span>
              <a href="#" className="hover:text-white transition-colors">免责声明</a>
            </div>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors">
                <i className="ri-weibo-line text-sm text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors">
                <i className="ri-wechat-line text-sm text-background-50"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}